import noSearchResult from "assets/illustrations/noSearch.svg"
import { useTranslation } from "react-i18next"
import { FiestaImage } from "utility-components"

import s from "./LeaderboardEmpty.module.scss"

// TODO [https://jira.attensi.com/browse/WEB-21324] Make this component prettier
export const LeaderboardEmpty = () => {
  const { t } = useTranslation()

  return (
    <div className={s.empty}>
      <FiestaImage
        alt=""
        sizes="50px"
        src={noSearchResult}
        className={s.empty__image}
      />
      <div className={s.empty__details}>
        <p className={s.empty__title}>{t("leaderboard.NO_PLAYERS")}</p>
      </div>
    </div>
  )
}
